<template>
    <div class="generate-ppt p-2 mb-4" id="generate-ppt-page">
        <!-- <h2 class="mb-2">{{ canExport('insights') ? 'Generate Presentation' : 'View Presentation' }}</h2> -->

        <div class="row px-2 mb-5">
            <nav id="generate-ppt-tab-nav" class="navbar navbar-expand primary-tab-bar">
                <div class="container-fluid">
                    <div class="collapse navbar-collapse">
                        <ul class="navbar-nav">
                            <li v-for="tab_name in generate_ppt_tabs" :key="tab_name" class="nav-item">
                                <a class="nav-link d-flex flex-nowrap primary-tab" 
                                   :class="{'primary-tab-active': tab_name === generate_ppt_tab_active}"
                                   href="#" 
                                   role="button" 
                                   aria-expanded="false" 
                                   @click.prevent="setActiveTab(tab_name)">
                                    <span>{{ tab_name }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <div class="px-0">
                <div v-if="generate_ppt_tab_active === 'Build Presentation'">
                    <generate-presentation-build-new 
                        :client="client" 
                        :report_pages="report_pages"
                        ref="generate">
                    </generate-presentation-build-new>
                </div>
                <div v-if="generate_ppt_tab_active === 'Previous Presentations'">
                    <generate-presentation-previous-list 
                        :client="client" 
                        :exports="exports"
                        @clone="clonePresentation">
                    </generate-presentation-previous-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import { defineComponent } from 'vue';
    import permissionsMixin from '../../mixins/permissions';

    export default defineComponent({
        name: 'GeneratePresentation',
        mixins: [permissionsMixin],
        components: {
            Swal
        },
        props: {
            report_pages: {
                type: Array,
                required: true
            },
            client: {
                type: Object,
                required: true
            },
            exports: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                generate_ppt_tabs: ['Build Presentation', 'Previous Presentations'],
                generate_ppt_tab_active: 'Build Presentation',
            };
        },
        beforeMount() {
            if(!this.canExport('insights')) {
                this.generate_ppt_tabs = ['Previous Presentations'];
                this.generate_ppt_tab_active = 'Previous Presentations';
            }
        },
        methods: {
            clonePresentation(data) {
                this.setActiveTab('Build Presentation');
                this.$nextTick(() => {
                    this.$refs.generate.clonePresentation(data);
                });
            },
            setActiveTab(tab_name) {
                this.generate_ppt_tab_active = tab_name;
                this.$forceUpdate();
            },
        }
    });
</script>
